import * as angular from 'angular';
import {IController} from "angular";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";

export class serviceSendToMarketDialogCtrl implements IController {
  ids: any;

  private working: boolean;
  private bodyText: any;
  private secondText: any;

  /* @ngInject */
  constructor(private $mdDialog, private $route, private $filter, private deliveriesAlertsService: DeliveriesAlertsService) {
  }

  $onInit() {
    this.bodyText = this.ids.length > 1 ?
      this.$filter('translate')('CONFIRM_SEND_TO_MARKET_X_DELIVERIES', {value: this.ids.length}) :
      this.$filter('translate')('CONFIRM_SEND_TO_MARKET_DELIVERY_ID', {value: this.ids[0]});

    this.secondText = '';
    if (this.ids.length > 1) {
      this.secondText = 'Select whether to create one route or separate deliveries';
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  };

  createSingleRoute() {
    this.working = true;
    return this.$route().$put(this.ids)
      .then(() => {
        if (this.ids.length > 1) {
          this.deliveriesAlertsService.sendToMarketManySuccess();
        } else {
          this.deliveriesAlertsService.sendToMarketSuccess();
        }
        this.$mdDialog.hide(this.ids);
      })
      .catch((error) => {
        if (this.ids.length > 1) {
          this.deliveriesAlertsService.sendToMarketManyError();
        } else {
          this.deliveriesAlertsService.sendToMarketError();
        }
      })
      .finally(() => {
        this.working = false;
      });
  };

  createMultipleRoutes() {
    this.working = true;
    return this.$route().$put(this.ids, {separate: true})
      .then(() => {
        if (this.ids.length > 1) {
          this.deliveriesAlertsService.sendToMarketManySuccess();
        } else {
          this.deliveriesAlertsService.sendToMarketSuccess();
        }

        this.$mdDialog.hide(this.ids);
      })
      .catch((error) => {
        if (this.ids.length > 1) {
          this.deliveriesAlertsService.sendToMarketManyError();
        } else {
          this.deliveriesAlertsService.sendToMarketError();
        }
      })
      .finally(() => {
        this.working = false;
      });
  };


}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceSendToMarketDialog', {
    bindings: {
      ids: '<'
    },
    template: require('./service-send-to-market-dialog.html').default,
    controller: serviceSendToMarketDialogCtrl
  });
